import React from 'react'

import {
  BigCalendarAvailabilityIndividualCell,
  BigCalendarOptionsIndividualCell,
} from './components/BigCalendarCellsIndividual'
import {
  HouseAvailabilityICalendarOutputDto,
  HouseAvailabilityIndividualOutputDto,
} from '../../../../../../../lib/graphql'
import { HouseContextIndividual } from '../../../../helpers/assert-house-price-type'
import { BigCalendarICalendarCell } from '../../../shared/calendar/components/cell/icalendar/BigCalendarICalendarCell'

export type BigCalendarCellIndividualProps = {
  house: HouseContextIndividual
  availability:
    | null
    | HouseAvailabilityIndividualOutputDto
    | HouseAvailabilityICalendarOutputDto
  cellDate: Date
}
export const BigCalendarCellIndividual = ({
  house,
  availability,
  cellDate,
}: BigCalendarCellIndividualProps) => {
  return (
    <>
      {availability ? (
        <>
          {availability.__typename === 'HouseAvailabilityICalendarOutputDto' ? (
            <BigCalendarICalendarCell />
          ) : availability.__typename ===
            'HouseAvailabilityIndividualOutputDto' ? (
            <BigCalendarAvailabilityIndividualCell
              availability={availability}
              house={house}
            />
          ) : null}
        </>
      ) : (
        <BigCalendarOptionsIndividualCell house={house} cellDate={cellDate} />
      )}
    </>
  )
}
